export enum AgeGroup{
  INFANT = 'INFANT', //0-2
  PRESCHOOL = 'PRESCHOOL', //2-5
  CHILD = 'CHILD', //5-13
  ADOLESCENT = 'ADOLESCENT', //13-19
  ADULT = 'ADULT', //19-65
  ELDERLY = 'ELDERLY' //>65
}
